import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p384037348982181888',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
